import { queryKey } from '../constants/queryClientKey';
import { createBodyPart, deleteBodyPart, getBodyParts } from '../apis/bodyPart.api';
import { sortObjectKeys } from '@vindr/utils/helpers/common.helper';
import {
  useMutation,
  useQuery,
  useQueryClient,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { updateBodyPart } from '../apis/bodyPart.api';

export function useGetBodyParts(
  params: Parameters<typeof getBodyParts>[0],
  options?: UseQueryOptions
) {
  return useQuery([queryKey.bodyPart, sortObjectKeys(params)], () => getBodyParts(params), {
    keepPreviousData: true,
    ...options,
  }) as UseQueryResult<Awaited<ReturnType<typeof getBodyParts>>>;
}

export function useCreateBodyPart() {
  const queryClient = useQueryClient();

  return useMutation(
    async (params: Parameters<typeof createBodyPart>[0]) => createBodyPart(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.bodyPart]);
      },
      onError: (err) => {
        console.error('useCreateBodyPart:', err);
      },
    }
  );
}

export function useUpdateBodyPart() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, data }: { id: string; data: Parameters<typeof updateBodyPart>[1] }) =>
      updateBodyPart(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.bodyPart]);
      },

      onError: (err) => {
        console.error('useUpdateBodyPart:', err);
      },
    }
  );
}

export function useDeleteBodyPart() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => deleteBodyPart(id), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKey.bodyPart]);
    },
    onError: (err) => {
      console.error('useDeleteBodyPart:', err);
    },
  });
}
